// extracted by mini-css-extract-plugin
export var iframeWrapper = "PageBodyCarousel-module--iframeWrapper--72a02";